//房貸試算
class Mortgage {
  constructor() {
    this.form     = $('#mortgage');
    this.price    = this.form.find('.price');
    this.pv       = this.form.find('input[name=pv]');
    this.rate     = this.form.find('input[name=rate]');
    this.year     = this.form.find('select[name=year]');
    this.gYear    = this.form.find('select[name=gYear]');
    this.mr1      = this.form.find('.mr1');
    this.mr2      = this.form.find('.mr2');
    this.rangeNum = 0.7;
  }
  //僅輸入數字
  onlyNumKey() {
    this.form.find('input').on('input', (e) => {
      const $this   = $(e.currentTarget);
      let filterVal = $this.val().replace(/[！-～]/g, (tmpStr) => {
        return String.fromCharCode(tmpStr.charCodeAt(0) - 0xFEE0);
      });
      $this.val(filterVal.replace(/[^0-9\.]/g, ''));
    });
  }
  //貸款金額
  filterPV() {
    // let price = 0;
    /*
    if(this.price != 0) {
      price = this.price;
    } else {
      price = this.inputPrice;
    }*/
    let filterPrice = this.price.text().replace(',', '');
    let realPrice   = filterPrice * 10000;
    let resultPrice = Math.round(realPrice * this.rangeNum);
    this.pv.val(resultPrice);
  }
  //寬限期內每月利息
  totalPrice1(rate, pv) {
    let result = pv * ((rate / 100) / 12);
    if(result == 0 || isNaN(result)){
      result = 0;
    }
    this.mr1.text(result.toFixed(2));
  }
  //寬限期後每月本息 (Excel PMT 公式)
  totalPrice2(rate, nper, pv) {
    let rateFilter = (rate / 100) / 12;
    let nperFilter = nper * 12;
    let result = Math.floor((pv * rateFilter) / (1 - Math.pow(1 + rateFilter, (-1 * nperFilter))) * 100) / 100;
    if(result == 0 || isNaN(result)){
      result = 0;
    }
    this.mr2.text(result.toFixed(2));
  }
  //執行計算帶入各值
  resultVal() {
    this.totalPrice1(this.rate.val(), this.pv.val());
    this.totalPrice2(this.rate.val(), (this.year.val() - this.gYear.val()), this.pv.val());
  }
  resultMortgage() {
    this.onlyNumKey();
    this.filterPV();
    this.resultVal();

    //總價
    this.inputPrice.on('keydown keyup', () => {
      this.resultVal();
    });

    //貸款金額
    this.pv.on('keydown keyup', () => {
      this.resultVal();
    });
    //銀行貸款利率
    this.rate.on('keydown keyup', () => {
      this.resultVal();
    });
    //貸款總年限
    this.year.on('change blur', () => {
      this.resultVal();
    });
    //寬限期
    this.gYear.on('change blur', () => {
      this.resultVal();
    });
  }
}


//房貸計算機
class Mortgage2 {
  constructor() {
    this.form     = $('#mortgage2');
    this.price    = this.form.find('input[name=price]');  //總價
    // this.inputPrice = this.form.find('input[name=price]');  //用輸入的總價
    this.pv       = this.form.find('input[name=pv]'); //貸款金額
    this.rate     = this.form.find('input[name=rate]'); //貸款利率
    this.year     = this.form.find('select[name=year]');  //貸款年限
    this.gYear    = this.form.find('select[name=gYear]'); //寬限期
    this.mr1      = this.form.find('.mr1'); //寬限期內每月利息
    this.mr2      = this.form.find('.mr2');  //寬限期後每月本息
    this.rangeNum = 0.7;
  }
  //僅輸入數字
  onlyNumKey() {
    this.form.find('input').on('input', (e) => {
      const $this   = $(e.currentTarget);
      let filterVal = $this.val().replace(/[！-～]/g, (tmpStr) => {
        return String.fromCharCode(tmpStr.charCodeAt(0) - 0xFEE0);
      });
      $this.val(filterVal.replace(/[^0-9\.]/g, ''));
    });
  }
  //貸款金額
  filterPV() {
    let filterPrice = this.price.text().replace(',', '');
    let realPrice   = filterPrice * 10000;
    let resultPrice = Math.round(realPrice * this.rangeNum);
    this.pv.val(resultPrice);
  }
  //寬限期內每月利息
  totalPrice1(rate, pv) {
    let result = pv * ((rate / 100) / 12);
    if(result == 0 || isNaN(result)){
      result = 0;
    }
    this.mr1.text(result.toFixed(2));
  }
  //寬限期後每月本息 (Excel PMT 公式)
  totalPrice2(rate, nper, pv) {
    let rateFilter = (rate / 100) / 12;
    let nperFilter = nper * 12;
    let result = Math.floor((pv * rateFilter) / (1 - Math.pow(1 + rateFilter, (-1 * nperFilter))) * 100) / 100;
    if(result == 0 || isNaN(result)){
      result = 0;
    }
    this.mr2.text(result.toFixed(2));
  }
  //執行計算帶入各值
  resultVal() {
    this.totalPrice1(this.rate.val(), this.pv.val());
    this.totalPrice2(this.rate.val(), (this.year.val() - this.gYear.val()), this.pv.val());
  }
  resultMortgage() {
    this.onlyNumKey();
    this.filterPV();
    this.resultVal();

    //總價
    this.price.on('keydown keyup', () => {
      this.resultVal();
    });

    //貸款金額
    this.pv.on('keydown keyup', () => {
      this.resultVal();
    });
    //銀行貸款利率
    this.rate.on('keydown keyup', () => {
      this.resultVal();
    });
    //貸款總年限
    this.year.on('change blur', () => {
      this.resultVal();
    });
    //寬限期
    this.gYear.on('change blur', () => {
      this.resultVal();
    });
  }
}




//表單輸入名稱
class InputVal {
  constructor(){
    this.customerVal    = $('input[name=customer]');
    this.telVal         = $('input[name=tel]');
    this.eMailVal       = $('input[name=email]');
    this.classesVal     = $('select[name=classes]');
    this.messageVal     = $('textarea[name=message]');
    this.checkTxtNumVal = $('#checkTxtNum>span');
    this.termsVal       = $('input[name=terms]');
    this.errorVal       = $('p.error');
    this.submitBtn      = $('button[type=submit]');

    //正規表達式
    this.regexTxt   = /^[a-zA-Z\u4e00-\u9fa5]+$/;
    this.regexNum   = /[0-9]/;
    this.regexEmail = /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,4}$/;
  }
  customerVal(el) {
    if(el.val() == ''){
      el.parent().next().show();
      el.parent().next().text('請填寫您的姓名。');
    }else if(el.val() != '' && this.regexTxt.test(el.val()) != true){
      el.parent().next().show();
      el.parent().next().text('請勿輸入數字或特殊符號。');
    }else if(el.val().length < 2){
      el.parent().next().show();
      el.parent().next().text('此欄位長度不可小於2文字。');
    }else if(el.val().length >= 10){
      el.parent().next().show();
      el.parent().next().text('此欄位長度不可超過10文字。');
    }else{
      el.parent().next().hide();
      el.parent().next().text('');
    }
  }
  telVal(el) {
    if(el.val() == ''){
      el.next().show();
      el.next().text('請填寫您的聯絡電話。');
    }else if(el.val() != '' && this.regexNum.test(el.val()) != true){
      el.next().show();
      el.next().text('您輸入的電話格式錯誤。');
    }else{
      el.next().hide();
      el.next().text('');
    }
  }
  eMailVal(el) {
    if(el.val() == ''){
      el.next().show();
      el.next().text('請輸入您常用的電子郵件。');
    }else if(el.val() != '' && this.regexEmail.test(el.val()) != true){
      el.next().show();
      el.next().text('您輸入的電子郵件格式錯誤。');
    }else{
      el.next().hide();
      el.next().text('');
    }
  }
  classesVal(el) {
    if(el.val() == '無'){
      el.parent().next().show();
      el.parent().next().text('請選擇諮詢類別。');
    }else{
      el.parent().next().hide();
      el.parent().next().text('');
    }
  }
  messageVal(el) {
    if(el.val() == ''){
      el.parent().next().show();
      el.parent().next().text('請填寫您的諮詢內容。');
    }else{
      el.parent().next().hide();
      el.parent().next().text('');
    }
  }
  realtyTxtNum(el) {
    let maxLength  = 200;
    let nowContent = el.val();
    let nowLehgth  = nowContent.length;

    this.checkTxtNum.text(maxLength - nowLehgth);

    if(nowLehgth > maxLength){
      el.parent().next().show();
      el.parent().next().text('您的諮詢內容已超過' + maxLength + '字，請簡述。');
      this.checkTxtNum.text('已超過' + maxLength + '字。');
    }else{
      el.parent().next().hide();
      el.parent().next().text('');
    }
  }
  contactTxtNum(el) {
    let maxLength  = 200;
    let nowContent = el.val();
    let nowLehgth  = nowContent.length;

    this.checkTxtNum.text(maxLength - nowLehgth);

    if(nowLehgth > maxLength){
      el.parent().next().show();
      el.parent().next().text('您的諮詢內容已超過' + maxLength + '字，請簡述。');
      this.checkTxtNum.text('已超過' + maxLength + '字。');
    }
  }
  termsVal(el) {
    if(el.prop('checked') != true){
      el.next().next().show();
      el.next().next().text('請確認已了解並勾選同意條款。');
    }else{
      el.next().next().hide();
      el.next().next().text('');
    }
  }
}




//預約看屋 & 降價通知 & 買屋留言
class RealtyFormEvent extends InputVal {
  constructor(el) {
    super();
    this.form        = el;
    this.customer    = this.form.find(this.customerVal);
    this.tel         = this.form.find(this.telVal);
    this.eMail       = this.form.find(this.eMailVal);
    this.message     = this.form.find(this.messageVal);
    this.checkTxtNum = this.form.find(this.checkTxtNumVal);
    this.terms       = this.form.find(this.termsVal);
    this.error       = this.form.find(this.errorVal);
    this.submit      = this.form.find(this.submitBtn);
  }
  checkForm() {
    //姓名
    this.customer.focusout((e) => {
      const $this = $(e.currentTarget);
      super.customerVal($this);
    });
    //電話
    this.tel.focusout((e) => {
      const $this = $(e.currentTarget);
      super.telVal($this);
    });
    /*
    //信箱
    this.eMail.focusout((e) => {
      const $this = $(e.currentTarget);
      super.eMailVal($this);
    });
    */
    //備註
    super.realtyTxtNum(this.message);
    this.message.focusout((e) => {
      const $this = $(e.currentTarget);
      super.realtyTxtNum($this);
    });
    this.message.on('keydown keyup', (e) => {
      const $this = $(e.currentTarget);
      super.realtyTxtNum($this);
    });
    //同意條款
    this.terms.on('click', (e) => {
      const $this = $(e.currentTarget);
      super.termsVal($this);
    });
    //送出
    this.submit.on('click', (e) => {
      super.customerVal(this.customer);
      super.telVal(this.tel);
      //super.eMailVal(this.eMail);
      super.realtyTxtNum(this.message);
      super.termsVal(this.terms);
      if(this.error.filter(':hidden').length == this.error.length){
        $(e.currentTarget).css({
          'pointerEvents': 'none',
          'opacity'      : .5 
        });
        // return false;
      }else{
        return false;
      }
    });
  }
}




//物件列表 & 內頁 (RWD)
class RealtyForm extends RealtyFormEvent {
  constructor() {
    super($('#realtyForm'));
  }
  checkForm() {
    super.checkForm(this.form);
  }
}




//側邊欄
class AsideRealtyForm extends RealtyFormEvent {
  constructor() {
    super($('#asideRealtyForm'));
  }
  checkForm() {
    super.checkForm(this.form);
  }
}




//業務個人
class PersonalForm extends RealtyFormEvent {
  constructor() {
    super($('#personalForm'));
  }
  checkForm() {
    super.checkForm(this.form);
  }
}




//客服信箱
class ContactForm extends InputVal {
  constructor() {
    super();
    this.form        = $('#contactForm');
    this.customer    = this.form.find(this.customerVal);
    this.tel         = this.form.find(this.telVal);
    this.eMail       = this.form.find(this.eMailVal);
    this.classes     = this.form.find(this.classesVal);
    this.message     = this.form.find(this.messageVal);
    this.checkTxtNum = this.form.find(this.checkTxtNumVal);
    this.terms       = this.form.find(this.termsVal);
    this.error       = this.form.find(this.errorVal);
    this.submit      = this.form.find(this.submitBtn);
  }
  checkForm() {
    //姓名
    this.customer.focusout((e) => {
      const $this = $(e.currentTarget);
      super.customerVal($this);
    });
    //電話
    this.tel.focusout((e) => {
      const $this = $(e.currentTarget);
      super.telVal($this);
    });
    /*
    //信箱
    this.eMail.focusout((e) => {
      const $this = $(e.currentTarget);
      super.eMailVal($this);
    });
    */
    //類別
    this.classes.on('change blur', (e) => {
      const $this = $(e.currentTarget);
      super.classesVal($this);
    });
    //內容
    this.message.focusout((e) => {
      const $this = $(e.currentTarget);
      super.messageVal($this);
      super.contactTxtNum($this);
    });
    this.message.on('keydown keyup', (e) => {
      const $this = $(e.currentTarget);
      super.contactTxtNum($this);
    });
    //同意條款
    this.terms.on('click', (e) => {
      const $this = $(e.currentTarget);
      super.termsVal($this);
    });
    //送出
    this.submit.on('click', (e) => {
      super.customerVal(this.customer);
      super.telVal(this.tel);
      //super.eMailVal(this.eMail);
      super.classesVal(this.classes);
      super.messageVal(this.message);
      super.contactTxtNum(this.message);
      super.termsVal(this.terms);
      if(this.error.filter(':hidden').length == this.error.length){
        $(e.currentTarget).css({
          'pointerEvents': 'none',
          'opacity'      : .5 
        });
        return true;
      }else{
        return false;
      }
    });
  }
}




//輸出
export {Mortgage, Mortgage2, PersonalForm, RealtyForm, AsideRealtyForm, ContactForm};


// WEBPACK FOOTER //
// ./js_new/form.js